import { NavLink, useMatch } from "react-router-dom";
import { Link, LinkProps } from "@mui/material";

import { StyledIconLink } from "./IconLink.styles";

export type IconLinkProps = LinkProps & {
  /**
   * The icon to be displayed in the link.
   * This should be a React component that renders an icon.
   */
  Icon: React.ElementType;
  /**
   * The active icon if it should be different when the link is active.
   * @default Icon
   */
  ActiveIcon?: React.ElementType;
  /**
   * The URL to navigate to when the link is clicked.
   */
  to: string;
  /**
   * The children to be rendered inside the link, i.e. the label or text.
   */
  children?: React.ReactNode;
};

export const IconLink: React.FC<IconLinkProps> = ({ children, Icon, ActiveIcon = Icon, to, ...rest }: IconLinkProps) => {
  const matches = useMatch(to);
  let icon = <Icon />;
  if (matches !== null) {
    icon = <ActiveIcon />;
  }
  return (
    <StyledIconLink>
      <Link component={NavLink} to={to} {...rest}>
        <span className="icon">{icon}</span>
        {children}
      </Link>
    </StyledIconLink>
  );
};
